<template>
  <div class="news-headlines-detail">
        <!-- <newsHeader :page='1'></newsHeader> -->
         <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <!-- <el-breadcrumb-item :to="{ path: '/list/training' }">{{content[$route.params.id]}}</el-breadcrumb-item> -->
            <el-breadcrumb-item>{{article.title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-detail-wrapper main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{article.title}}</h3>
                        <p class="source f12">{{article.source}}</p>
                        <div class="summary f12 flex-align-between">
                            <div class="box">
                                <span>{{article.createTime}}</span>
                                <span class="eye">{{article.views}}</span>
                            </div>
                           
                        </div>
                    </div>
                    <div class="content" v-html="article.content">
                        
                    </div>
                  
                </div>
            </div>
           
        </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
        article:{},
        content:{
            10:'考生须知',
            11:'考试时间',
            12:'报名流程',
        },
        }
    },
    watch: {
        '$route': function(to,from){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    methods: {
         async GetArticleHead(id){
            let params = {
                id :id
            }
            let resData = await Api.Home.getDetail(params)
            this.article = resData.data;
         },

        async getNewsList() {
            let params = {
                clazz: this.$route.params.id,
                pageNum:1,
                pageSize:1,
            }
            let resData = await Api.Home.getNewsList(params);
            if(resData.rows.length>0) {
                this.GetArticleHead(resData.rows[0].dId)
            }
        },


        
    },
    mounted(){
        this.getNewsList();
        // this.GetArticleHead();
       
         
    },

}
</script>

<style lang="less">
    @import "./less/news_headlines_detail.less";
</style>